import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PointTagsComponent } from './point-tags.component';

@NgModule({
  declarations: [PointTagsComponent],
  imports: [
    CommonModule
  ]
})
export class PointTagsModule { }
